import { FC, ReactNode } from 'react';
import { cn } from '@/shared/lib/utils';

type Props = {
  /** Подпись показателя */
  label: string;
  /** Значение показателя */
  children: ReactNode;
  /** Класс значения: величина, у которой есть свой цвет (влияние), красится им */
  valueClassName?: string;
};

/** Плитка показателя: подпись сверху, значение под ней. */
export const StatTile: FC<Props> = ({ label, children, valueClassName }) => (
  <div className="flex flex-col gap-1 rounded-xl border border-border bg-card p-3">
    <span className="text-xs text-muted-foreground">{label}</span>
    <span className={cn('text-lg font-semibold text-foreground tabular-nums', valueClassName)}>{children}</span>
  </div>
);
